import { render } from "./PageLoadSpinner.vue?vue&type=template&id=6f484cdd&lang=pug"
import script from "./PageLoadSpinner.vue?vue&type=script&lang=js"
export * from "./PageLoadSpinner.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QPage from 'quasar/src/components/page/QPage.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QPage});
